export default [
    {
        key: 'impressions',
        label: 'Impressions / Page',
        format: '0,00a',
    },
    {
        key: 'clicks',
        label: 'Clicks / Page',
        format: '0,00a',
        yAxisID: 'y1',
    },
];
